import type { RouteLocation } from 'vue-router';
import { useGlobalStore } from '~/stores/global';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  window.yaContextCb = window.yaContextCb || [];
  const router = useRouter();
  const globalStore = useGlobalStore();
  const mediaQuery = useMediaQueryStore();
  const interactiveStore = useInteractiveStore();
  if (interactiveStore.isPageSpeedBot) return;
  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (!isProd || globalStore.webview) return;

  function init() {
    const script = document.createElement('script');
    script.src = 'https://yandex.ru/ads/system/context.js';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    script.addEventListener('load', () => {
      try {
        if (!mediaQuery.isMobile) {
          router.afterEach(
            (_: RouteLocation, from: { name: RouteLocation }) => {
              if (from.name && window?.Ya?.adfoxCode) {
                window.Ya.adfoxCode.reload(null, { onlyIfWasVisible: true });
              }
            }
          );
        }
      } catch (e) {
        console.error('vl plugin', e);
      }
    });
  }

  interactiveStore.addFunction(init);
});
